import { Icon, Switch } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import { Button } from '@moleculeone/ui';
import cx from 'classnames';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { apiClient } from '@f/api-client';
import { toggleDebugMode } from '@f/services/administration/administration.actions';

import cls from './DebugTools.module.css';

interface DebugToolsProps {
  isDebugModeEnabled: boolean;
  toggleDebugMode: () => void;
}

function DebugTools(props: DebugToolsProps) {
  const { isDebugModeEnabled } = props;

  function onDebugModeToggle() {
    props.toggleDebugMode();
  }

  return (
    <div className={cx(cls.container, cls.aboveAll)}>
      <Popover2
        portalClassName={cls.aboveAll}
        interactionKind="hover"
        placement="bottom-end"
        content={
          <div className={cls.content} data-test="debug-tools">
            <Switch
              data-test="debug-mode-switch"
              className={cls.debugModeSwitch}
              checked={isDebugModeEnabled}
              onChange={onDebugModeToggle}
              label="Debug mode"
            />
            <NavLink to="/dashboard/synthesis-browser">Synthesis browser</NavLink>
            <Button
              text="+10k credits"
              onClick={() => {
                apiClient.organization.debugAddCredits();
              }}
              size="small"
            />
          </div>
        }
      >
        <Icon data-test="debug-tools-icon" icon="wrench" size={10} />
      </Popover2>
    </div>
  );
}

interface State {
  administration: {
    debug: {
      isDebugModeEnabled: boolean;
    };
  };
}

export default connect(
  (state: State) => ({ isDebugModeEnabled: state.administration.debug.isDebugModeEnabled }),
  {
    toggleDebugMode,
  }
)(DebugTools);
